export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-api.worknest.cloud',
};
